module.exports = __webpack_public_path__ + "img/hohlsaum_signalgelb_ral1003.31370c4c.jpg";